import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SpecSettingsProvider } from './contexts/SpecSettingsContext';
import { BootProvider } from './contexts/BootContext';
import { AnnaWall } from './pages/AnnaWall';
import { SpecStyle } from './pages/SpecStyle';
import { CommandCenter } from './pages/CommandCenter';
import { Telefoon } from './pages/Telefoon';
import { Logboek } from './pages/beheer/Logboek';
import { Agents } from './pages/beheer/Agents';
import { Geheugen } from './pages/beheer/Geheugen';
import { Huis } from './pages/beheer/Huis';
import { Systeem } from './pages/beheer/Systeem';
import { AnnaSettings } from './pages/beheer/AnnaSettings';
interface AppProps {
  /** Signature accent proposal: luminous teal or warm gold */
  accent?: 'teal' | 'gold';
  /** How expressive Anna's micro-behaviours are: gaze, blinks, sighs, perk-ups */
  aliveness?: 'calm' | 'lively';
  /** Play the "anna → orb" boot sequence on first load of the session */
  bootAnimation?: boolean;
}
export function App({
  accent = 'teal',
  aliveness = 'lively',
  bootAnimation = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3mjzpgvevclx2">
      <SpecSettingsProvider accent={accent} aliveness={aliveness} data-id="element-1" data-mp="3mj6ipufwtwex">
        <BootProvider enabled={bootAnimation} data-id="element-2" data-mp="3rcsxpt9jqcdw">
          <Routes data-id="element-3" data-mp="5ygolyg4xb6">
            <Route path="/" element={<AnnaWall data-id="element-5" data-mp="4n6a3ahwrb3" />} data-id="element-4" data-mp="67z9oh5w26u" />
            <Route path="/bureau" element={<CommandCenter data-id="element-7" data-mp="2zld2jatxbhc2" />} data-id="element-6" data-mp="82k72sfnuax" />
            <Route path="/telefoon" element={<Telefoon data-id="element-9" data-mp="2zn6aquk6q9m6" />} data-id="element-8" data-mp="2zm4vedw4z0yn" />
            <Route path="/spec" element={<SpecStyle data-id="element-11" data-mp="33nq6btp41567" />} data-id="element-10" data-mp="33mf3bw3ho1g5" />
            <Route path="/beheer" element={<Navigate to="/beheer/logboek" replace data-id="element-13" data-mp="38lrp0dimj2h5" />} data-id="element-12" data-mp="33mym1f0yqtv8" />
            <Route path="/beheer/logboek" element={<Logboek data-id="element-15" data-mp="38o4d78ez692n" />} data-id="element-14" data-mp="38l00tnrcw70w" />
            <Route path="/beheer/agents" element={<Agents data-id="element-17" data-mp="3dmfolnkx4rmz" />} data-id="element-16" data-mp="3dle46si0issl" />
            <Route path="/beheer/geheugen" element={<Geheugen data-id="element-19" data-mp="nwc23tmizxws" />} data-id="element-18" data-mp="3dii3wxiozs0z" />
            <Route path="/beheer/huis" element={<Huis data-id="element-21" data-mp="nxwv3et6z8sj" />} data-id="element-20" data-mp="nv0z3w0wmu6q" />
            <Route path="/beheer/systeem" element={<Systeem data-id="element-23" data-mp="st2heeqiaph5" />} data-id="element-22" data-mp="su45bjsmf6ga" />
            <Route path="/beheer/anna" element={<AnnaSettings data-id="element-25" data-mp="35yomiyqxk0x" />} data-id="element-24" data-mp="swq9d9gaz3tr" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-27" data-mp="38kxqn1ac7l9" />} data-id="element-26" data-mp="356rh3pi3e8j" />
          </Routes>
        </BootProvider>
      </SpecSettingsProvider>
    </BrowserRouter>;
}